module.exports = __webpack_public_path__ + "img/BackofPass-Serial.6bf17986.png";